module.exports = __webpack_public_path__ + "static/img/9.0260734.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/9.jpg
// module id = 6r8H
// module chunks = 1